import { FACEBOOK, INSTAGRAM, LINKEDIN, TWITTER, TIKTOK_BUSINESS } from '@/lib/socialProfile';

import { MANAGE_COMMENTS_TRACKER } from '@/lib/routes/privateRoutes';

export const getTabsList = (t) => {
    return {
        [INSTAGRAM]: [
            {
                name: t('tabs.comment'),
                icon: 'conversations',
                url: MANAGE_COMMENTS_TRACKER
            },
            {
                name: t('tabs.mention'),
                icon: 'mentions',
                url: MANAGE_COMMENTS_TRACKER
            }
        ],
        [FACEBOOK]: [
            {
                name: t('tabs.comment'),
                icon: 'conversations',
                url: MANAGE_COMMENTS_TRACKER
            }
        ],
        [TWITTER]: [],
        [LINKEDIN]: [
            {
                name: t('tabs.comment'),
                icon: 'conversations',
                url: MANAGE_COMMENTS_TRACKER
            }
        ],
        [TIKTOK_BUSINESS]: [
            {
                name: t('tabs.comment'),
                icon: 'conversations',
                url: MANAGE_COMMENTS_TRACKER
            }
        ]
    };
};
